import { AppBar, useScrollTrigger } from "@mui/material";

interface TopAppBarProps {
  // The content area under the TopAppBar
  scrollTarget?: HTMLDivElement;
  children?: React.ReactElement;
}

// The z-index of an AppBar with fixed position. We need to set AppBar position as static
// to show content area below it, but need to set a proper z-index so that the content
// scroll behind the AppBar.
const appBarZIndex = 1100;

// The AppBar allows content to scroll behind it, and it uses elevation (such as a drop shadow)
// to visually distinguish itself from the scrolling content.
const TopAppBar: React.FC<TopAppBarProps> = ({ scrollTarget, children }) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: scrollTarget,
  });

  return (
    <AppBar
      role="navigation"
      position="static"
      elevation={trigger ? 2 : 0}
      sx={{ zIndex: appBarZIndex }}
    >
      {children}
    </AppBar>
  );
};

export default TopAppBar;
